// -----------------------------------------------------------------------------
// Anaglyphic, Netherlands @ 2023.
// See README in the root project for more information.
// -----------------------------------------------------------------------------

import { useI18n, createI18n } from "vue-i18n";

// -----------------------------------------------------------------------------

export type Translations = {
	en: string | object;
	nl: string | object;
};

const i18n = createI18n({
	legacy: false,
	globalInjection: true,
	locale: "en",
	fallbackRoot: false,
	fallback: false,
	messages: {
		en: {},
		nl: {},
	},
});

// vue-i18n automatically handles fallback logic, but for the graph-worker we manually need to handle it.
i18n.global.fallbackLocale.value = "en";

export const t = i18n.global.t;
export const te = i18n.global.te;

export { useI18n };
export default i18n;
